import { makeStyles, SkeletonItem } from '@fluentui/react-components';
import React from 'react';

const useStyles = makeStyles({
  container: {
    maxWidth: '100%',
    height: '100%',
    margin: '1rem 0.5rem',
  },
  grid: {
    alignItems: "center",
    display: "grid",
    paddingBottom: "10px",
    position: "relative",
    gap: "12px",
    gridTemplateColumns: "min-content 25% 25% 20% 20%",
  },
})

export const AppListPageSkeleton: React.FC = () => {
  const classes = useStyles();
  const shimmerStyles = (width: string) => {
    return {
      height: "16px",
      maxWidth: width,
      marginTop: "5px",
      marginBottom: "5px",
    }
  }
  return (
    <div className={classes.container}>
      <div style={{ marginTop: "2rem" }}>
        <SkeletonItem style={shimmerStyles("10%")} />
        <SkeletonItem style={shimmerStyles("30%")} />
      </div>
      <AppListTableSkeleton />
    </div>
  )
};

export const AppListTableSkeleton: React.FC = () => {
  const classes = useStyles();
  return (
    <div style={{ padding: "1rem" }}>
      {Array.from({ length: 8 }).map((_, index) => (
        <div key={index} className={classes.grid}>
          <SkeletonItem shape="square" size={24} />
          <SkeletonItem size={16} />
          <SkeletonItem size={16} />
          <SkeletonItem size={16} />
          <SkeletonItem size={16} />
        </div>
      ))}
    </div>
  )
}